const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  name: (lambdaParameter, value) =>
    `${lambdaParameter}.Name.Contains("${value}")`,
  fileExtension: (lambdaParameter, value) =>
    `"${value}".Contains(${lambdaParameter}.FileExtension)`,
  customerIds: (lambdaParameter, value) =>
    `${lambdaParameter}.Customer.Id.Equals(${value})`,
}

const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
